export default __webpack_public_path__ + "static/media/flag.c3b0fd6d.svg";